import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  private http = inject(HttpClient);

  private baseApiUrl = environment.apiUrl;
  // Renamed from /api/v1/log on 2026-09-20; the server still serves the old prefix
  // for one release, so a stale bundle keeps working.
  private apiUrl = this.baseApiUrl + '/api/v1/user-log';

  getAll(params: any = {}): Observable<any> {
    console.log('LogService.getAll called with params:', params);
    console.log('API URL:', this.apiUrl);

    // Add includePagination option for backend
    const queryParams = {
      ...params,
      options: JSON.stringify({ includePagination: true })
    };

    // Rename 'limit' to 'perPage' for backend compatibility
    if (params.limit) {
      queryParams.perPage = params.limit;
      delete queryParams.limit;
    }

    return this.http.get(this.apiUrl, { params: queryParams });
  }

  getById(logId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${logId}`);
  }

  deleteLog(logId: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${logId}`);
  }

  getStats(): Observable<any> {
    return this.http.get(`${this.apiUrl}/stats`);
  }

  getFilterOptions(): Observable<any> {
    return this.http.get(`${this.apiUrl}/filter-options`);
  }
}
